import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const WhyWeBuildItSection = () => {
  const navigate = useNavigate();

  return (
    <section className="section-padding bg-[#60416D] relative overflow-hidden mx-[20px] md:mx-0 rounded-[8px] md:rounded-none">
      <div className="relative z-10 mx-[20px] md:max-w-7xl md:mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-[50px]">
          {/* Image - Left side on desktop, bottom on mobile */}
          <div className="order-2 md:order-1 flex-shrink-0 overflow-hidden rounded-[8px]">
            <img
              src="/images/img3.jpg"
              alt="Why we built it"
              className="rounded-[8px] object-cover w-full h-full"
              style={{ width: '329px', height: '353px', transform: 'scale(1.2)' }}
            />
            <style dangerouslySetInnerHTML={{
              __html: `
                @media (min-width: 768px) {
                  .order-2 img {
                    width: 416px !important;
                    height: 431px !important;
                  }
                }
              `
            }} />
          </div>

          {/* Content - Right side on desktop, top on mobile */}
          <div className="order-1 md:order-2 flex-1 text-center md:text-left">
            <h2
              className="font-bold text-white responsive-title leading-none mb-6"
              style={{
                fontSize: '28px',
                letterSpacing: '-1px',
                verticalAlign: 'middle'
              }}
            >
              <style dangerouslySetInnerHTML={{
                __html: `
                  @media (min-width: 768px) {
                    .responsive-title {
                      font-size: 60px !important;
                      letter-spacing: -2px !important;
                    }
                  }
                `
              }} />
              We built it for the moments we almost forgot.
            </h2>

            <p className="text-white/80 max-w-2xl mx-auto md:mx-0 mb-8" style={{ fontSize: '14px', fontFamily: 'Euclid Circular A' }}>
              <style dangerouslySetInnerHTML={{
                __html: `
                  @media (min-width: 768px) {
                    .order-1 p {
                      font-size: 1.25rem !important;
                    }
                  }
                `
              }} />
              We've missed birthdays. Forgotten small things that meant a lot. Not because we didn't care, but because life got loud.
            </p>

            <Button
              variant="outline"
              size="lg"
              onClick={() => navigate('/about')}
              className="text-[#60416D] border-white bg-white hover:bg-gray-100 font-semibold rounded-[8px]"
            >
              Read our full story
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWeBuildItSection;
